import { useQuery } from "@tanstack/react-query";

import { fetchEnabledAppIds } from "../lib/appAccess";
import { useShellStore } from "../store";

/**
 * Org-level app enablement for the current user, from /api/v1.0/config/apps/.
 * Returns null until loaded or when the fetch fails — callers must fail open
 * (see lib/appAccess.ts isAppEnabled). Keyed by user id so a login switch
 * refetches; 5-minute staleTime bounds how long a super-admin toggle takes to
 * reach an already-open session (a reload always refetches).
 */
export function useEnabledApps(): Set<string> | null {
  const user = useShellStore((s) => s.user);
  const { data } = useQuery({
    queryKey: ["enabled-app-ids", user?.id ?? ""],
    queryFn: () =>
      fetchEnabledAppIds(() => useShellStore.getState().getValidAccessToken()),
    enabled: !!user,
    staleTime: 5 * 60 * 1000,
  });
  return data ?? null;
}
